import styled from "styled-components"

export const QuantityWrapper = styled.div`
    .quantity{
        &_list{
            display: flex;
            list-style: none;
            margin: 0;
            padding: 0;
            &_item{
                width: 50px;
                height: 40px;
                border: 1px solid #e19292;
                &_control{
                    cursor: pointer;
                    &:hover{
                        background-color: #e9e9e9;
                    }
                }
                div{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    input{
                        width: 100%;
                        height: 100%;
                        border: none;
                        outline: none;
                        text-align: center;
                    }
                }
            }
        }
    }
`
